import {
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Table,
    Button,
    TablePagination,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import en from '../../../../lang/en-us';
import { getInactiveFolios } from '../../../../redux-store/actions/link';
import { InactiveFolioPaths, IndividualFolioRequestType } from '../types';
import { parseInactiveFoliosData, RequestStatus, RequestStatusLabelMap } from './utils';

const { dashboard } = en;

const TrackRequest = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {
        state: { pan, reqId, registerDetails, summaryData: summaryDataFromLocation = null },
    } =
        useLocation<{
            reqId: string;
            pan: string;
            registerDetails: { by: string; details: string };
            summaryData?: IndividualFolioRequestType[];
        }>();
    const [summaryData, setSummaryData] = useState<IndividualFolioRequestType[] | null>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    useEffect(() => {
        async function callApi() {
            try {
                const { body: getInactiveFoliosResponse } = await getInactiveFolios({
                    reqId,
                    pan,
                    pekrn: '',
                })(dispatch);
                if (getInactiveFoliosResponse.success) {
                    // Sort the data by reqId in descending order
                    const sortedData = parseInactiveFoliosData(getInactiveFoliosResponse.success)
                        .sort((a, b) => b.reqId.localeCompare(a.reqId));
                    setSummaryData(sortedData);
                }
            } catch (err: any) {
                alert(err.message);
            }
        }
        if (!summaryDataFromLocation) {
            callApi();
        } else {
            // Sort the data by reqId in descending order for data from location
            const sortedData = parseInactiveFoliosData(summaryDataFromLocation)
                .sort((a, b) => b.reqId.localeCompare(a.reqId));
            setSummaryData(sortedData);
        }
    }, []);
    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.inactiveFolios.trackRequest.heading}
            </h2>
            <div style={{ borderRadius: '10px' }} className="card-bg">
                <div
                    className="transmission-download-content"
                    style={{
                        display: 'flex',
                        margin: '20px 0px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <h2
                        style={{
                            color: '#000',
                            fontSize: '21px',
                            fontWeight: 'bold',
                        }}
                    >
                        {dashboard.inactiveFolios.trackRequest.tableHeading}
                    </h2>
                    <Button
                        style={{
                            fontWeight: 'bold',
                            color: '#A484DC',
                            padding: '12px 24px',
                            fontSize: '12px',
                            marginBottom: '10px',
                            cursor: 'pointer',
                            border: '1px solid #A484DC',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            textTransform: 'capitalize',
                            minWidth: '210px',
                        }}
                        onClick={() => {
                            history.replace(`/links${InactiveFolioPaths.SEARCH}`, {
                                registerDetails,
                                reqId,
                                pan,
                            });
                        }}
                    >
                        Search With different name
                    </Button>
                </div>
                <div className="desktop_mode">
                    <TableContainer style={{ borderRadius: '8px', border: '1px solid #eceef3' }}>
                        <Table
                            className="transmission-download-table"
                            style={{ borderRadius: '8px', border: '1px solid #eceef3' }}
                        >
                            <TableHead style={{ background: '#eceef3' }}>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            borderRight: '0px',
                                            color: '#828282',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {dashboard.inactiveFolios.trackRequest.columns.requestId}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            borderRight: '0px',
                                            color: '#828282',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {dashboard.inactiveFolios.trackRequest.columns.status}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            borderRight: '0px',
                                            color: '#828282',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                        }}
                                    >
                                        Investor Name
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            borderRight: '0px',
                                            color: '#828282',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {dashboard.inactiveFolios.trackRequest.columns.details}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {summaryData &&
                                    summaryData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((data) => {
                                            return (
                                                <TableRow style={{ borderBottom: '0px' }}>
                                                    <TableCell
                                                        style={{
                                                            borderWidth: '0px 1px 0px 0px',
                                                            borderColor: '#d2d2d2',
                                                            color: '#828282',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            borderRight: '1px solid #d2d2d2',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {data.reqId}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            borderWidth: '0px 1px 0px 0px',
                                                            borderColor: '#d2d2d2',
                                                            borderRight: '1px solid #d2d2d2',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                                color:
                                                                    data.status ===
                                                                    RequestStatus.Completed
                                                                        ? ' #489A47'
                                                                        : data.status ===
                                                                          RequestStatus.Pending
                                                                        ? ' #DFBB00'
                                                                        : data.status ===
                                                                          RequestStatus.NoDataFound
                                                                        ? '#DFBB00'
                                                                        : data.status ===
                                                                          RequestStatus.Failure
                                                                        ? 'red'
                                                                        : 'unset',
                                                                border:
                                                                    data.status ===
                                                                    RequestStatus.Completed
                                                                        ? '1px solid #489A47'
                                                                        : data.status ===
                                                                          RequestStatus.Pending
                                                                        ? '1px solid #DFBB00'
                                                                        : data.status ===
                                                                          RequestStatus.NoDataFound
                                                                        ? '1px solid #DFBB00'
                                                                        : data.status ===
                                                                          RequestStatus.Failure
                                                                        ? '1px solid red'
                                                                        : 'unset',
                                                                maxWidth: '210px',
                                                                margin: '0 auto',
                                                                textAlign: 'center',
                                                                background:
                                                                    data.status ===
                                                                    RequestStatus.Completed
                                                                        ? '#EDF8ED'
                                                                        : data.status ===
                                                                          RequestStatus.Pending
                                                                        ? '#FEF8DB'
                                                                        : data.status ===
                                                                          RequestStatus.NoDataFound
                                                                        ? '#FCF2E3'
                                                                        : 'unset',
                                                            }}
                                                        >
                                                            {RequestStatusLabelMap[data.status]}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            borderWidth: '0px 1px 0px 0px',
                                                            borderColor: '#d2d2d2',
                                                            color: '#828282',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            borderRight: '1px solid #d2d2d2',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {data.data[0]?.invName || '-'}
                                                    </TableCell>
                                                    {data.status === RequestStatus.Completed && (
                                                        <TableCell
                                                            style={{
                                                                borderWidth: '0px 1px 0px 0px',
                                                                borderColor: '#d2d2d2',
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer',
                                                                color: '#828282',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                textAlign: 'center',
                                                            }}
                                                            onClick={() => {
                                                                history.push(
                                                                    `/links${InactiveFolioPaths.SUMMARY}`,
                                                                    {
                                                                        summaryData: data.data,
                                                                        reqId: data.reqId,
                                                                        status: data.status,
                                                                        pan,
                                                                        registerDetails,
                                                                    },
                                                                );
                                                            }}
                                                        >
                                                            View
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            );
                                        })}
                                {summaryData && rowsPerPage - Math.min(rowsPerPage, summaryData.length - page * rowsPerPage) > 0 && (
                                    <TableRow style={{ height: 53 * (rowsPerPage - Math.min(rowsPerPage, summaryData.length - page * rowsPerPage)) }}>
                                        <TableCell colSpan={4} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        {summaryData && (
                            <TablePagination
                                rowsPerPageOptions={[5]}
                                component="div"
                                count={summaryData.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                style={{ borderTop: '1px solid #eceef3' }}
                            />
                        )}
                    </TableContainer>
                </div>
                <div className="mobile_mode">
                    {summaryData &&
                        summaryData.map((data) => (
                            <div
                                className="transmission-download-mobile-single"
                                style={{
                                    border: '1px solid gray',
                                    borderRadius: '5px',
                                    marginBottom: '10px',
                                }}
                            >
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>
                                        {dashboard.inactiveFolios.trackRequest.columns.requestId}
                                    </h4>
                                    <p>{data.reqId}</p>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>
                                        {dashboard.inactiveFolios.trackRequest.columns.status}
                                    </h4>
                                    <p>{RequestStatusLabelMap[data.status]}</p>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>
                                        Investor Name
                                    </h4>
                                    <p>{data.data[0]?.invName || '-'}</p>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>
                                        {dashboard.inactiveFolios.trackRequest.columns.details}
                                    </h4>
                                    <p style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                        View
                                    </p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default TrackRequest;
